<template>
	<div class="">
		<div class="clearfloat">
			<div class="imgs flo_lf"><img @click="xin.goUrl('/personalCenter/head')" :src="user.avatar"/></div>
			<div class="message_box flo_lf">
				<div class="user_name"> {{user.nickname}}</div>
				<div>您的会员级别为：<span class="user_vip">{{user.type | isVip}}</span></div>
				<div>您回到同仁化学中国！您的上一次登录时间：{{user.last_time*1000 | timeFormat}}</div>
				<div class="upde_btn">选择要上传的头像</div>
				<div class="imgupde">
					<span>仅支持JPG,GIF,PNG图片文件,且文件小于5M</span>
					<el-upload
						:headers="{token}" accept=".gif,.png,.jpg"
						class="avatar-uploader" name="files"
						action="/api/other/upload"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="imageUrl" :src="imageUrl" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					<button class="laing_btn" v-preventReClick @click="Postuserupdate">确定</button>
				</div>
			</div>
		</div>
		

	</div>
</template>

<script>
	import {mapState,mapMutations,mapActions} from 'vuex'
	export default{
		data(){
			return {
				imageUrl:''
			}
		},
		filters:{
		},
		computed:{
			...mapState(['user','token'])
		},
		watch:{
			$route(to,frm){
				this.setclassName(to.path);
			}
		},
		created(){
		},
		
		methods:{
			...mapActions(['getUser']),
			...mapMutations(['setclassName']),
			async Postuserupdate(){
				if(!this.imageUrl){
					this.$message.error('请选择头像图片');
					return;
				}
				let {code} = await this.api.Postuserupdate({
					avatar:this.imageUrl
				});
				if(code==200){
					await  this.getUser();
					this.$message.success('提交成功!');
					this.xin.goUrl('/personalCenter/personal');
				}
			},
			handleAvatarSuccess(res, file) {
				if(res.code == 200)
					this.imageUrl = res.data;
			},
			beforeAvatarUpload(file){//图片验证
				let isJPG =false;
				let type = file.name.substring(file.name.lastIndexOf('.')+1);
				switch(type){//gif、jpg、png、word、excel、txt、zip、ppt、pdf
					case 'gif':case 'jpg':case 'png':
						isJPG= true;
					break;
				}
				const isLt2M = file.size / 1024 / 1024 < 5;
				if (!isJPG) {
					this.$message.error('头像图片只能是 gif、jpg、png格式!');
				}
				if (!isLt2M) {
					this.$message.error('头像图片大小不能超过 5MB!');
				}
				return isJPG && isLt2M;
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
.upde_btn{
	// width: ;
}
.imgupde{
	margin-top: 40px;
	// margin-left: ;
}
 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
	border: 1px solid;
    font-size: 28px;
    color: #8c939d;
    width: 280px;
    height: 280px;
    line-height: 280px;
    text-align: center;
  }
  .avatar {
    width: 280px;
    height: 280px;
    display: block;
  }
</style>

